
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import nemet from "../../assets/nemet.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarNemet({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar német fordító</title>
                <meta name='description' content="Ingyenes magyar német fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar német fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-nemet-fordito" />
            </Helmet>
            <h1>Magyar német fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és német nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={nemet} alt="német zászló"></img>
                </div>


                <p>A magyar és a német nyelv között számos különbség van. Íme néhány jellemző eltérés a két nyelv között:</p>
                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A magyar ugor-altaikus nyelvcsaládba tartozik, míg a német az indoeurópai nyelvcsaládba, a germán nyelvek csoportjába. Ez azt jelenti, hogy a két nyelvnek eltérő eredete és nyelvtörténete van.</li>

                    <li><b>Hangzás és kiejtés</b>: A magyar és a német nyelv hangzásai és fonetikai rendszere is különbözik egymástól. Például a németben több hangzó és ejtési variáció található, amelyek a magyarban nem léteznek, és fordítva.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a német nyelv nyelvtani struktúrája is eltérő. A német nyelvben például bonyolultabb ragozás és névelőrendszer van, míg a magyar nyelvben más nyelvtani jellemzők, például a ragok használata dominál.</li>

                    <li><b>Szórend</b>: A magyar és a német nyelvben eltérő szórendi szerkezetek jellemzőek. Míg a magyarban a szórend általában rugalmasabb, a németben a szavaknak gyakran szabályosabb sorrendje van.</li>

                    <li><b>Írásrendszer</b>: A magyar nyelv latin betűs írásrendszert használ, míg a németben a latin betűkkel kibővített német ábécét alkalmazzák. Néhány hangzó vagy betű jelentése és kiejtése is eltérő lehet a két nyelvben.</li>

                    <li><b>Szókincs</b>: A magyar és a német nyelvnek eltérő szókincse van, amelyek tükrözik a két kultúra és nyelv témakörei közti különbséget.</li>
                </ul>
                <div className="sectionbottom">
                    <Link to="/nemet-magyar-fordito">Német magyar fordító</Link>
                    <img src={nemet} alt="német zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarNemet;